import {
  CREATESTAFF,
  DELETESTAFF,
  LISTOFSTAFF,
  UPDATESTAFF,
  UPDATESTATUSSTAFF,
  VIEWSTAFF,
} from "./ApiRoutes";
import { authData } from "./services";

export const createStaff = async (data: object) => {
  const response = await authData.post(CREATESTAFF, data);
  return response?.data;
};
export const updateStaff = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATESTAFF}${id}`, data);
  return response?.data;
};
export const listOfStaff = async (data: object) => {
  const response = await authData.post(LISTOFSTAFF, data);
  return response?.data;
};
export const viewStaff = async (id: number) => {
  const response = await authData.get(`${VIEWSTAFF}${id}`);
  return response?.data;
};
export const deleteStaffApi = async (id: number) => {
  const response = await authData.delete(`${DELETESTAFF}${id}`);
  return response?.data;
};
export const updateStatusStaff = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATESTATUSSTAFF}${id}`, data);
  return response?.data;
};
